import { render, staticRenderFns } from "./provider-remittances-table.vue?vue&type=template&id=bc8fddb8&"
import script from "./provider-remittances-table.vue?vue&type=script&lang=js&"
export * from "./provider-remittances-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports